import { render, staticRenderFns } from "./SearchV3Header.vue?vue&type=template&id=10cf1d8a"
import script from "./SearchV3Header.vue?vue&type=script&lang=js"
export * from "./SearchV3Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports